import React from 'react';
import BasicCli from '../../main/components/basicCli/BasicCli';
import CompanyEmailNotification from './CompanyEmailNotification';

const CompanyEmailNotificationPage: React.FC = () => {
  return (
    <BasicCli>
      <div className="bcPageContent">
        <CompanyEmailNotification />
      </div>
    </BasicCli>
  );
};

export default CompanyEmailNotificationPage;
